import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import * as firebase from 'firebase';
import { ProdutoElement } from '../../interfaces/produto';
import { NgxSpinnerService } from "ngx-spinner";
import { MatStepper } from '@angular/material/stepper';
import { MatDialog } from '@angular/material/dialog';
import { AngularFireDatabase } from "@angular/fire/database";
import { AngularFireStorage } from "@angular/fire/storage";

import { NovoGrupoDialog } from '../dialogs/novo-grupo-dialog/novo-grupo-dialog';
import { UploadImagemDialogDialog } from '..//dialogs/upload-imagem-dialog/upload-imagem-dialog';

import { NovoUnidadeMedidaDialog } from '../dialogs/novo-unidade-medida-dialog/novo-unidade-medida-dialog';
import { NovoFornecedorDialog } from '../dialogs/novo-fornecedor-dialog/novo-fornecedor-dialog';

import { take } from 'rxjs/operators';

let bCodigoBarras = true;

@Component({
  selector: 'app-novo-produto',
  templateUrl: './novo-produto.component.html',
  styleUrls: ['./novo-produto.component.scss', '../../styles/estilo.padrao.scss']
})
export class NovoProdutoComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;

  uid;
  produtoForm: FormGroup;

  bCaracterEspecial: boolean = false;

  grupos: any[] = [];
  fornecedores: any[] = [];
  unidadesMedidas: any[] = [];

  tipoItem: any[] = [
    { value: 'Venda', name: 'Venda' },
    { value: 'Consumo', name: 'Consumo' },
    { value: 'Imobilizado', name: 'Imobilizado' }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private db: AngularFireDatabase,
    private storage: AngularFireStorage
  ) {
    this.spinner.show('novo-produto');
    this.uid = localStorage.getItem('uid')
  }

  ngOnInit(): void {
    this.produtoForm = this.formBuilder.group({
      img64: [false, null],
      urlImagem: ['', null],
      nomeProduto: ['', [Validators.required]],
      unidade: ['', [Validators.required]],
      descricaoComplementar: ['', [Validators.required]],
      referencia: ['', null],
      quantidadeAtacado: [0, null], //Quando valor atacado preenchido, este item será obrigatório
      quantidadeMaxima: [1, [Validators.required, Validators.min(1)]], //Quando valor atacado preenchido, este item será obrigatório
      quantidadeEstoque: [0, [Validators.required, Validators.min(0)]],
      quantidadeMinimaAlertaEstoque: [1, [Validators.required, Validators.min(1)]], // irá gerar um alerta quando a quantidade em estoque estiver abaixo deste parâmetro
      custoCompra: [0, null],
      valor: [0, [Validators.required, Validators.min(0.01)]], //Nunca 0
      valorCopia: [0, null], //Nunca 0
      valorAtacado: [0, null], //Quando alterado, quantidade para atacado será obrigatório
      lucroBruto: [0, null],
      comissao: [0, null],
      codigo: [0, [Validators.required]],
      identificador: ['', null],
      //Adicionar na documentação
      grupo: ['', [Validators.required]], //Opcional - Se não selecionado, grupo "Geral"
      fornecedorPreferencial: ['', null],
      tipoItem: ['', [Validators.required]],
      taxaICMSISS: ['', [Validators.required]],
      taxaICMSISSCFe: ['', [Validators.required]],
      // codBarras: ['', [Validators.required, statusCodigoBarras]],
      codBarras: ['', null],
      quantidadeMinima: [1, null],
      custoMedio: ['0', null],
      valorPromocional: [0, null],
      periodoPromocionalInicial: [new Date(), null],
      periodoPromocionalFinal: [new Date(), null],
    });

    this.produtoForm.get('codigo').disable();
    // this.produtoForm.get('tipoIPI').disable();
    this.produtoForm.get('custoMedio').disable();
    // this.produtoForm.get('quantidadeEstoque').disable();
    this.produtoForm.get('valorCopia').disable();

    this.getGrupos(null);
    this.getUnidadesMedidas(null);
    this.getFornecedores(null);
  }

  novoFornecedor() {
    const dialogRef = this.dialog.open(NovoFornecedorDialog);
    dialogRef.afterClosed().subscribe(result => {

      result ? this.getFornecedores(result) : null;
    });
  }

  novoUnidadesMedida() {
    const dialogRef = this.dialog.open(NovoUnidadeMedidaDialog);
    dialogRef.afterClosed().subscribe(result => {

      result ? this.getUnidadesMedidas(result) : null;
    });
  }

  novoProduto() {
    const dialogRef = this.dialog.open(NovoGrupoDialog);
    dialogRef.afterClosed().subscribe(result => {

      result ? this.getGrupos(result) : null;
    });
  }

  getFornecedores(idFornecedor) {
    //Recupera os fornecedores
    this.usuarioService.getFornecedores(this.uid).pipe(take(1)).subscribe(snap => {
      this.fornecedores = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          if (dados.Status) {
            this.fornecedores.push({
              value: item.key,
              name: dados.NomeFantasia
            });
          }
        });

        //Ordena alfabeticamente
        this.fornecedores.sort((a, b) => a.name.localeCompare(b.name));

        if (idFornecedor) {
          this.produtoForm.get('fornecedorPreferencial').patchValue(this.fornecedores[this.fornecedores.findIndex(x => x.value === idFornecedor)].value);
        }
      }
    });

    //Recupera o código para um novo produto
    this.usuarioService.getContCodigoProdutos(this.uid).subscribe(snap => {
      this.produtoForm.get('codigo').patchValue(Number(snap) + 1);

      setTimeout(() => this.spinner.hide('novo-produto'), 1000);
    });
  }

  getUnidadesMedidas(idUnidade) {
    //Recupera unidades de medidas cadastradas
    this.usuarioService.getUnidadesMedidas(this.uid).pipe(take(1)).subscribe(snap => {
      this.unidadesMedidas = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          this.unidadesMedidas.push({
            value: dados.Nome,
            name: dados.Nome,
            idUnidade: item.key
          });
        });

        //Ordena alfabeticamente
        this.unidadesMedidas.sort((a, b) => a.value.localeCompare(b.value));

        if (idUnidade) {
          this.produtoForm.get('unidade').patchValue(this.unidadesMedidas[this.unidadesMedidas.findIndex(x => x.idUnidade === idUnidade)].value);
        }
      }
    });
  }

  getGrupos(idGrupo) {
    //Recupera grupos cadastrados
    this.usuarioService.getGrupos(this.uid).pipe(take(1)).subscribe(snap => {
      this.grupos = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          this.grupos.push({
            value: dados.Nome,
            name: dados.Nome,
            idGrupo: item.key
          });
        });

        //Ordena alfabeticamente
        this.grupos.sort((a, b) => a.value.localeCompare(b.value));

        if (idGrupo) {
          this.produtoForm.get('grupo').patchValue(this.grupos[this.grupos.findIndex(x => x.idGrupo === idGrupo)].value);
        }
      }
    });
  }


  bitToPNG() {
    /* Retorna a base 64 para PNG */
    var binary = atob(this.f.img64.value.split(',')[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: 'image/png'
    });
    /* Fim */
  }

  async cadastrar() {
    this.spinner.show('default');

    //Tratamento de obrigatoriedade feito a mão
    if (this.validarCampos()) {
      if (bCodigoBarras) {

        if (this.f.img64.value) {
          try {

            const img = this.bitToPNG();

            var n = Date.now();
            const filePath = `IpanemaImagens/${n}`;
            const fileRef = this.storage.ref(filePath);
            const task = this.storage.upload(`IpanemaImagens/${n}`, img).then(url => {
              let downloadURL = fileRef.getDownloadURL();
              downloadURL.subscribe(url => {
                if (url) {
                  this.produtoForm.get('urlImagem').patchValue(url);
                  this.finalizarCadastro();
                }
              });
            });
          } catch (e) {
            console.log(e)
            this.spinner.hide('default');

            this.usuarioService.setLog("Erro ao realizar o upload da foto do produto!", e, this.uid);
            this.toastr.error('Erro ao realizar o upload da foto do produto!!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/novo-produto"]));
          }
        } else {
          this.finalizarCadastro();
        }
      } else {
        this.toastr.error('Este código de barras já consta no sistema!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
        this.produtoForm.get('codBarras').markAsTouched();
        setTimeout(() => this.spinner.hide('default'), 500);
      }
    } else {
      this.toastr.warning('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('default'), 500);
    }
  }

  async finalizarCadastro() {
    try {
      this.db.object('Clientes/' + this.uid + '/ContCodigoProdutos').query.ref.transaction(valor => {
        if (valor) {
          valor++;
          this.produtoForm.get('codigo').patchValue(valor);
          return valor;
        }
        return valor;

      }).then(async response => {

        const map: ProdutoElement = {
          //Parte 1
          URL_Imagem: this.f.urlImagem.value.length > 0 ? this.f.urlImagem.value : false,
          TipoItem: this.f.tipoItem.value,
          Unidade: this.f.unidade.value,
          IDUnidade: this.unidadesMedidas[this.unidadesMedidas.findIndex(x => x.value === this.f.unidade.value)].idUnidade,
          Nome: this.f.nomeProduto.value.trim(),
          NomeBusca: this.f.nomeProduto.value.trim().toLowerCase(),
          Grupo: this.f.grupo.value,
          IDGrupo: this.grupos[this.grupos.findIndex(x => x.value === this.f.grupo.value)].idGrupo,
          IDFornecedorPreferencial: this.f.fornecedorPreferencial.value,
          CodigoBarras: this.f.codBarras.value.trim(),
          DescricaoComplementar: this.f.descricaoComplementar.value.trim(),
          Referencia: this.f.referencia.value.trim(),
          //Parte 2
          Valor: this.f.valor.value,
          ValorAtacado: this.f.valorAtacado.value,
          QuantidadeAtacado: this.f.quantidadeAtacado.value,
          QuantidadeEstoque: this.f.quantidadeEstoque.value,
          QuantidadeMinimaAlertaEstoque: this.f.quantidadeMinimaAlertaEstoque.value,
          QuantidadeMinima: this.f.quantidadeMinima.value,
          QuantidadeMaxima: this.f.quantidadeMaxima.value,
          Identificador: this.f.identificador.value,
          CodigoProduto: this.f.codigo.value, // Fazer em função em nuvem ou cadastro posterior
          LucroBruto: this.f.lucroBruto.value,
          Comissao: this.f.comissao.value,
          CustoCompra: this.f.custoCompra.value,
          CustoMedio: this.f.custoMedio.value,
          Status: true,
          //Parte 5
          ValorPromocional: this.f.valorPromocional.value,
          TimestampInicialPromocional: new Date(this.f.periodoPromocionalInicial.value).getTime(),
          TimestampFinalPromocional: new Date(this.f.periodoPromocionalFinal.value).getTime(),
          //Demais parâmetros
          TimestampCadastro: firebase.default.database.ServerValue.TIMESTAMP
        }

        console.log(map)

        try {
          const resp = await this.usuarioService.setProduto(map, this.uid);
          setTimeout(() => {
            this.spinner.hide('default');
            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/consultar-produto"], { queryParams: { IDProduto: resp } }));
          }, 2000);
        } catch (e) {
          console.log(e)
          this.spinner.hide('default');
          this.usuarioService.setLog("Erro ao cadastrar produto!", e, this.uid);
          this.toastr.error('Erro ao cadastrar produto!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
          this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/pages/novo-produto"]));
        }
      }).catch(err => {
        this.spinner.hide('default');
        this.usuarioService.setLog("Erro ao incrementar código no cadastro de produto!", err, this.uid);

        this.toastr.error('Erro ao incrementar código no cadastro de produto!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/novo-produto"]));
      });
    }
    catch (e) {
      console.log(e)
      this.spinner.hide('default');

      this.usuarioService.setLog("Erro ao cadastrar produto!", e, this.uid);
      this.toastr.error('Erro ao cadastrar produto!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
      this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
        this.router.navigate(["/pages/novo-produto"]));
    }
  }

  deletarFoto() {
    this.produtoForm.get('img64').patchValue(false);
  }

  uploadFoto() {
    const dialogRef = this.dialog.open(UploadImagemDialogDialog, {
      data: {
        img64: this.f.img64.value ? this.bitToPNG() : false,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.produtoForm.get('img64').patchValue(result);
      }
    });
  }

  paginas(b, pagina) {
    if (b) {
      let bAux = true;

      switch (pagina) {
        case 1:
          this.f.tipoItem.errors ? (this.produtoForm.get('tipoItem').markAsTouched(), bAux = false) : null;
          this.f.nomeProduto.errors ? (this.produtoForm.get('nomeProduto').markAsTouched(), bAux = false) : null;
          this.f.descricaoComplementar.errors ? (this.produtoForm.get('descricaoComplementar').markAsTouched(), bAux = false) : null;
          this.f.unidade.errors ? (this.produtoForm.get('unidade').markAsTouched(), bAux = false) : null;
          this.f.grupo.errors ? (this.produtoForm.get('grupo').markAsTouched(), bAux = false) : null;

          bAux ? this.stepper.next() : null;
          break;

        case 2:
          this.f.valor.errors ? (this.produtoForm.get('valor').markAsTouched(), bAux = false) : null;
          this.f.quantidadeMaxima.errors ? (this.produtoForm.get('quantidadeMaxima').markAsTouched(), bAux = false) : null;

          if (this.f.valorAtacado.value !== 0) {
            this.produtoForm.get('quantidadeAtacado').setValidators([Validators.required, Validators.min(1)]);
            this.produtoForm.get('quantidadeAtacado').updateValueAndValidity()
            this.f.quantidadeAtacado.errors ? (this.produtoForm.get('quantidadeAtacado').markAsTouched(), bAux = false) : null;

            this.f.valorAtacado.errors ? (this.produtoForm.get('valorAtacado').markAsTouched(), bAux = false) : null;
          } else {
            this.produtoForm.get('quantidadeAtacado').clearValidators();
            this.produtoForm.get('quantidadeAtacado').updateValueAndValidity()
          }

          bAux ? this.stepper.next() : null;
          break;

        case 3:

          this.f.cstNFe.errors ? (this.produtoForm.get('cstNFe').markAsTouched(), bAux = false) : null;
          this.f.csosnNFe.errors ? (this.produtoForm.get('csosnNFe').markAsTouched(), bAux = false) : null;
          this.f.cstCFe.errors ? (this.produtoForm.get('cstCFe').markAsTouched(), bAux = false) : null;
          this.f.csosnCFe.errors ? (this.produtoForm.get('csosnCFe').markAsTouched(), bAux = false) : null;
          this.f.taxaICMSISS.errors ? (this.produtoForm.get('taxaICMSISS').markAsTouched(), bAux = false) : null;
          this.f.taxaICMSISSCFe.errors ? (this.produtoForm.get('taxaICMSISSCFe').markAsTouched(), bAux = false) : null;
          this.f.cfopECF.errors ? (this.produtoForm.get('cfopECF').markAsTouched(), bAux = false) : null;
          this.f.cfopNF.errors ? (this.produtoForm.get('cfopNF').markAsTouched(), bAux = false) : null;
          this.f.ncm.errors ? (this.produtoForm.get('ncm').markAsTouched(), bAux = false) : null;

          if (this.f.cstNFe.value === '060' || this.f.cstNFe.value === '070' || this.f.cstNFe.value === '010' || this.f.cstNFe.value === '090') {
            this.produtoForm.get('cest').setValidators([Validators.required]);
            this.produtoForm.get('cest').updateValueAndValidity()
            this.f.cest.errors ? (this.produtoForm.get('cest').markAsTouched(), bAux = false) : null;
          } else {
            this.produtoForm.get('cest').clearValidators();
            this.produtoForm.get('cest').updateValueAndValidity()
          }

          bAux ? this.stepper.next() : null;
          break;

        case 4:
          bAux ? this.stepper.next() : null;
          break;
      }

    } else {
      pagina === 1 ? this.produtoForm.get('valor').enable() : null;
      this.stepper.previous();
    }
  }

  alteracaoValor(b) {
    this.produtoForm.get('valorCopia').patchValue(this.f.valor.value);
    if (b) {
      this.produtoForm.get('valorAtacado').setValidators([Validators.max(this.f.valor.value)]);
      this.produtoForm.get('valorAtacado').updateValueAndValidity();
    } else {
      this.produtoForm.get('valorAtacado').markAsTouched();
    }
  }

  alteracaoValorPromocional() {
    this.produtoForm.get('valorPromocional').setValidators([Validators.max(this.f.valor.value)]);
    this.produtoForm.get('valorPromocional').updateValueAndValidity();
    this.produtoForm.get('valorPromocional').markAsTouched();
  }

  limparCampos() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/novo-produto"]));
  }

  validaCodigoBarras() {
    this.usuarioService.getProdutoCodBarras(this.uid, this.f.codBarras.value).subscribe(snap => {
      bCodigoBarras = snap.length > 0 ? false : true;
      setTimeout(() => {
        this.f.codBarras.updateValueAndValidity()
      }, 100);
    });
  }

  //Trata cada campo, para ir para a página automaticamente...
  validarCampos() {
    let bAux = true;


    //Pagina 1 / 0
    this.f.tipoItem.errors ? (this.produtoForm.get('tipoItem').markAsTouched(), bAux = false) : null;
    this.f.nomeProduto.errors ? (this.produtoForm.get('nomeProduto').markAsTouched(), bAux = false) : null;
    this.f.unidade.errors ? (this.produtoForm.get('unidade').markAsTouched(), bAux = false) : null;
    this.f.grupo.errors ? (this.produtoForm.get('grupo').markAsTouched(), bAux = false) : null;

    if (!bAux) {
      this.stepper.selectedIndex = 0;
      return bAux;
    }

    //Pagina 2 / 1
    this.f.valor.errors ? (this.produtoForm.get('valor').markAsTouched(), bAux = false) : null;
    this.f.quantidadeMaxima.errors ? (this.produtoForm.get('quantidadeMaxima').markAsTouched(), bAux = false) : null;

    if (this.f.valorAtacado.value !== 0) {
      this.produtoForm.get('quantidadeAtacado').setValidators([Validators.required, Validators.min(1)]);
      this.produtoForm.get('quantidadeAtacado').updateValueAndValidity()
      this.f.quantidadeAtacado.errors ? (this.produtoForm.get('quantidadeAtacado').markAsTouched(), bAux = false) : null;
      this.f.valorAtacado.errors ? (this.produtoForm.get('valorAtacado').markAsTouched(), bAux = false) : null;
    } else {
      this.produtoForm.get('quantidadeAtacado').clearValidators();
      this.produtoForm.get('quantidadeAtacado').updateValueAndValidity()
    }

    if (!bAux) {
      this.stepper.selectedIndex = 1;
      return bAux;
    }

    if (!bAux) {
      this.stepper.selectedIndex = 2;
      return bAux;
    }

    this.f.valorPromocional.errors ? (this.produtoForm.get('valorPromocional').markAsTouched(), bAux = false) : null;
    if (!bAux) {
      this.stepper.selectedIndex = 4;
      return bAux;
    }

    return bAux;
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;

    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 44 || k == 47) {
      return true;
    } else {
      this.bCaracterEspecial = true;
      return false;
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.produtoForm.controls; }
}

function statusCodigoBarras() {
  return bCodigoBarras ? null : { statusCodigoBarras: false };
}
